import { ButtonComponent } from '@actiris/design-system';
import { BackButtonModule, ButtonModule, LanguageSelectionModule, ResponsiveModule } from '@actiris/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { APP_RESPONSIVE_CONFIG } from '../shared/actiris-forms/app.responsive-config';
import { MenuTriggerModule } from '../shared/directives/menu-trigger.module';
import { PermissionPipe } from '../shared/pipes/permission.pipe';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
    declarations: [HeaderComponent, FooterComponent, CookieBannerComponent],
    imports: [
        LanguageSelectionModule,
        TranslateModule,
        RouterModule,
        CommonModule,
        ResponsiveModule.forRoot(APP_RESPONSIVE_CONFIG),
        ButtonModule,
        BackButtonModule,
        MenuTriggerModule,
        ButtonModule,
        PermissionPipe,
        ButtonComponent,
    ],
    exports: [HeaderComponent, FooterComponent, CookieBannerComponent],
})
export class LayoutModule {}
